// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import Link from '@mui/material/Link';
import PropTypes from 'prop-types';

import useAttribute from '../../../../hooks/ModelInventory/useAttribute';
import {
  EMPTY_OBJECT,
  getFilteredEntityTypes,
} from '../../../../const/CommonConst';
import { getEntityDetailsRoutePath } from '../../../../utils/inventoryRouteEngine';

/**
 * Read-only Association value. The stored attribute value only has
 * entity_id/unique_id/entity_alias - no entity type - so the correct
 * route (e.g. /Model/..., /Use Case/...) can't be built from it directly.
 * This resolves the type the same way the edit-mode dropdown does: by
 * fetching this attribute's association options and matching this value
 * against them.
 */
const AssociationValueLink = ({
  value,
  attribute,
  entityData = EMPTY_OBJECT,
  formData = EMPTY_OBJECT,
}) => {
  const { getAssociationAttributesData } = useAttribute();
  const [resolvedHref, setResolvedHref] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const sourceAttributeId = Number.parseInt(attribute?.id);

    if (
      (!value?.entity_id && !value?.unique_id) ||
      !entityData?.entity_id ||
      !entityData?.entity_type ||
      Number.isNaN(sourceAttributeId)
    ) {
      return undefined;
    }

    const payload = {
      source_attribute_id: sourceAttributeId,
      form_data: formData,
      entity_id: entityData?.entity_id,
      entity_type: entityData?.entity_type,
    };

    getAssociationAttributesData(payload, false)
      .then((res) => {
        if (!isMounted) return;

        const matched = (res?.data || []).find(
          (option) =>
            option?.entity_id === value?.entity_id ||
            option?.unique_id === value?.unique_id
        );

        const matchedEntityType = getFilteredEntityTypes()?.find(
          (type) => type?.value === matched?.entity_type
        );

        if (matchedEntityType?.label) {
          setResolvedHref(
            getEntityDetailsRoutePath(matchedEntityType.label, value?.unique_id)
          );
        }
      })
      .catch(() => {});

    return () => {
      isMounted = false;
    };
  }, [
    attribute?.id,
    entityData?.entity_id,
    entityData?.entity_type,
    formData,
    value,
  ]);

  const label = (
    <>
      {value?.entity_alias}
      &nbsp; ({value?.unique_id})
    </>
  );

  if (!resolvedHref) {
    return <Typography variant="body1">{label}</Typography>;
  }

  return (
    <Link href={resolvedHref} target="_blank">
      <Typography variant="body1">{label}</Typography>
    </Link>
  );
};

AssociationValueLink.propTypes = {
  value: PropTypes.shape({
    entity_id: PropTypes.string,
    unique_id: PropTypes.string,
    entity_alias: PropTypes.string,
  }).isRequired,
  attribute: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  entityData: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.array,
      PropTypes.object,
    ])
  ),
  formData: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.array,
      PropTypes.object,
    ])
  ),
};

export default AssociationValueLink;
